<template>
  <div class="alignment-container">
    <div v-if="label" class="label">{{ label }}</div>

    <div class="horizontal">
      <button
        id="h-flex-start"
        :class="['align-button', { active: options.horizontal === 'flex-start' }]"
        @click="changed('horizontal', 'flex-start')"
      >
        <HorizontalLeft />
      </button>
      <button
        id="h-center"
        :class="['align-button', { active: options.horizontal === 'center' }]"
        @click="changed('horizontal', 'center')"
      >
        <HorizontalCenter />
      </button>
      <button
        id="h-flex-end"
        :class="['align-button', { active: options.horizontal === 'flex-end' }]"
        @click="changed('horizontal', 'flex-end')"
      >
        <HorizontalRight />
      </button>
      <button
        id="h-space-between"
        :class="['align-button', { active: options.horizontal === 'space-between' }]"
        @click="changed('horizontal', 'space-between')"
      >
        <HorizontalSpaceBetween />
      </button>
      <button
        id="h-space-around"
        :class="['align-button', { active: options.horizontal === 'space-around' }]"
        @click="changed('horizontal', 'space-around')"
      >
        <HorizontalSpaceAround />
      </button>
      <Tooltip target="h-flex-start" :text="$t('h-flex-start')"></Tooltip>
      <Tooltip target="h-center" :text="$t('h-center')"></Tooltip>
      <Tooltip target="h-flex-end" :text="$t('h-flex-end')"></Tooltip>
      <Tooltip target="h-space-between" :text="$t('h-space-between')"></Tooltip>
      <Tooltip target="h-space-around" :text="$t('h-space-around')"></Tooltip>
    </div>

    <div class="vertical">
      <button
        id="v-flex-start"
        :class="['align-button', { active: options.vertical === 'flex-start' }]"
        @click="changed('vertical', 'flex-start')"
      >
        <VerticalTop />
      </button>
      <button
        id="v-center"
        :class="['align-button', { active: options.vertical === 'center' }]"
        @click="changed('vertical', 'center')"
      >
        <VerticalCenter />
      </button>
      <button
        id="v-flex-end"
        :class="['align-button', { active: options.vertical === 'flex-end' }]"
        @click="changed('vertical', 'flex-end')"
      >
        <VerticalBottom />
      </button>
      <Tooltip target="v-flex-start" :text="$t('v-flex-start')"></Tooltip>
      <Tooltip target="v-center" :text="$t('v-center')"></Tooltip>
      <Tooltip target="v-flex-end" :text="$t('v-flex-end')"></Tooltip>
    </div>
  </div>
</template>

<script>
import HorizontalLeft from '@/assets/horizontal-left.svg'
import HorizontalCenter from '@/assets/horizontal-center.svg'
import HorizontalRight from '@/assets/horizontal-right.svg'
import HorizontalSpaceBetween from '@/assets/horizontal-space-between.svg'
import HorizontalSpaceAround from '@/assets/horizontal-space-around.svg'
import VerticalTop from '@/assets/vertical-top.svg'
import VerticalCenter from '@/assets/vertical-center.svg'
import VerticalBottom from '@/assets/vertical-bottom.svg'

export default {
  name: 'Alignment',
  i18nOptions: { keyPrefix: 'components.sidenav.shared.alignment' },
  components: {
    HorizontalLeft,
    HorizontalCenter,
    HorizontalRight,
    VerticalTop,
    VerticalCenter,
    VerticalBottom,
    HorizontalSpaceBetween,
    HorizontalSpaceAround,
  },
  props: {
    options: {
      type: Object,
      default() {
        return {
          horizontal: '',
          vertical: '',
        }
      },
    },
    label: {
      type: String,
      default: '',
    },
  },
  methods: {
    changed(axis, value) {
      this.$emit('change', {
        ...this.options,
        [axis]: this.options[axis] === value ? '' : value,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.alignment-container {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;

  .label {
    width: 100%;
    margin-bottom: 5px;
  }

  .align-button {
    margin: 0;
    border: none;
    outline: none;
    cursor: pointer;
    background: white;
    font-size: 24px;

    &.active svg {
      fill: $cherry;
    }
  }
}
</style>
